
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clm/reporting",
      function () {
        return require("private-next-pages/clm/reporting/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clm/reporting"])
      });
    }
  